export enum DOCUMENT_SHOW_TO_TYPE {
  ALL_ELIGIBLE_PERSONS = 'ALL_ELIGIBLE_PERSONS',
  OUTSIDE_US = 'OUTSIDE_US',
  US_ONLY = 'US_ONLY',
}
